module.exports = __webpack_public_path__ + "img/whiteBalls.10531233.png";